/**
 * Centralised TanStack Query keys. Keeping every cache key in one place makes
 * invalidation safer — when a write happens we just invalidate the right
 * factory function, no string scattering.
 */
export const qk = {
  me:              () => ['me'] as const,
  babies:          () => ['babies'] as const,
  baby:            (id: string) => ['babies', id] as const,
  babyAccess:      (id: string) => ['babies', id, 'access'] as const,
  babyInvites:     (id: string) => ['babies', id, 'invites'] as const,
  invitePreview:   (token: string) => ['invites', token, 'preview'] as const,
  babyMilestones:  (id: string) => ['babies', id, 'milestones'] as const,
  babyMilestone:   (id: string, mid: number) => ['babies', id, 'milestones', mid] as const,
  babyMilestoneGear: (id: string, mid: number) => ['babies', id, 'milestones', mid, 'gear'] as const,
  babyToday:       (id: string) => ['babies', id, 'today'] as const,
  babyActivity:    (id: string) => ['babies', id, 'activity'] as const,
  babyGrowth:      (id: string, metric?: string) =>
    metric ? (['babies', id, 'growth', metric] as const) : (['babies', id, 'growth'] as const),
  babyMilestoneMedia: (id: string, mid: number) =>
    ['babies', id, 'milestones', mid, 'media'] as const,
  babyMedia:       (id: string) => ['babies', id, 'media'] as const,
  babyActivities:  (id: string, category?: string) =>
    category ? (['babies', id, 'activities', 'cat', category] as const) : (['babies', id, 'activities'] as const),
  babyActivityDetail: (id: string, aid: number) => ['babies', id, 'activities', aid] as const,
  babyActivitySuggestions: (id: string) => ['babies', id, 'activities', 'suggestions'] as const,
  engagement:      (id: string, entityType: string, entityId: string | number) =>
    ['babies', id, 'engagement', entityType, String(entityId)] as const,
  babyPhotos:      (id: string) => ['babies', id, 'photos'] as const,
  babyQuestionnaires: (id: string) => ['babies', id, 'questionnaires'] as const,
  leaps:           () => ['leaps'] as const,
  milestones:      () => ['milestones'] as const,
  milestonesPublic: () => ['milestones', 'public'] as const,
  activitiesPublic: () => ['activities', 'public'] as const,
  gear:            () => ['gear'] as const,
  subscription:    () => ['me', 'subscription'] as const,
  babyEvents:      (id: string) => ['babies', id, 'events'] as const,
  notificationSettings: () => ['me', 'notification-settings'] as const,
  encryption:      (babyId: string) => ['babies', babyId, 'encryption'] as const,
  aiChats:         () => ['ai', 'chats'] as const,
  aiChat:          (sid: string) => ['ai', 'chats', sid] as const,
  aiSuggestions:   (babyId: string | null) => ['ai', 'suggestions', babyId ?? 'none'] as const,
  apiKeys:         () => ['me', 'api-keys'] as const,
} as const;
